module.exports = __webpack_public_path__ + "static/media/mineral-circular.24f68eb5.png";